import { BsListUl, BsGear } from 'react-icons/bs';
import { AiOutlineLineChart } from 'react-icons/ai'
import '../styles/NavBar.css'

const NavBar = ({ onClick, activeButton }) => {
  const buttonIds = ['chart', 'weights', 'settings'];
  return (
    <div className='navBar'>

      {/* Chart Button */}
      <div className=
      {`navButton ${activeButton === buttonIds[0] ? 'buttonActive' : ''}`} 
      onClick={() => {onClick(buttonIds[0])}}>
        <AiOutlineLineChart className='navIcon' style={{fontSize: 24, cursor: 'pointer'}}/>
        <p className='navText'>Chart</p>
      </div>

      {/* Weight List Button */}
      <div className=
      {`navButton ${activeButton === buttonIds[1] ? 'buttonActive' : ''}`} 
      onClick={() => {onClick(buttonIds[1])}}>
        <BsListUl className='navIcon' style={{fontSize: 24, cursor: 'pointer'}}/>
        <p className='navText'>Weights</p>
      </div>

      {/* Settings Button */}
      <div className=
      {`navButton ${activeButton === buttonIds[2] ? 'buttonActive' : ''}`} 
      onClick={() => {onClick(buttonIds[2])}}>
        <BsGear className='navIcon' style={{fontSize: 24, cursor: 'pointer'}}/>
        <p className='navText'>Settings</p>
      </div>

    </div>
  )
}

export default NavBar